<template>
  <div>
    <h5 class="f-110 mb-3 tail-line-dark">차트 관리</h5>
    <b-row no-gutters class="py-2 hover-gray">
      <b-col cols="4"> 차트 명</b-col>
      <b-col> {{ selected_chart_data.label }} </b-col>
    </b-row>

    <b-row no-gutters class="py-2 hover-gray">
      <b-col cols="4"> 적용된 보고 지표</b-col>

      <b-col>
        <div v-if="storyboard_linked_indicators[selected_chart_id]" class="mb-2">
          <span v-for="(item1, index1) in storyboard_linked_indicators[selected_chart_id]"
            :key="`story_board_${index1}`">
            <a class="cursor" @click="goHash(item1, 'STORY_BOARD')">
              웹 보고서 {{ item1?.sb_toc_lv1?.name }} > {{ item1?.sb_toc_lv2?.name }}
            </a>
            <br />
          </span>
        </div>

        <div v-for="code in gri_linked_indicators[selected_chart_id]" :key="code.id" class="mb-2">
          <a class="cursor" @click="goHash(code, 'GRI')">
            GRI {{ code }} 바로가기
          </a>
        </div>

        <div v-for="code in sasb_linked_indicators[selected_chart_id]" :key="code.id" class="mb-2">
          <a class="cursor" @click="goHash(code, 'SASB')">
            SASB {{ code }} 바로가기
          </a>
        </div>

        <div v-for="code in tcfd_linked_indicators[selected_chart_id]" :key="code.id" class="mb-2">
          <a class="cursor" @click="goHash(code, 'TCFD')">
            TCFD {{ code }} 바로가기
          </a>
        </div>

        <span v-for="(item, index) in chart_linked_indicators[selected_chart_id]" :key="`gri_${index}`">
          <a class="cursor" @click="goHash(item, 'DATA_CENTER')">
            Data Center {{ item['lv1_info']['name'] }} > {{ item['lv2_info']['name'] }}
          </a>
          <br />
        </span>
      </b-col>
    </b-row>

    <b-row no-gutters class="py-2 hover-gray">
      <b-col cols="4"> 모든 지표에서 차트 삭제</b-col>

      <b-col>
        <p v-if="['gri_linked_indicators','sasb_linked_indicators','tcfd_linked_indicators','chart_linked_indicators'].some(key => (this[key][selected_chart_id] || []).length)"
          class="mb-3">
        <span class="fw-600">{{ selected_chart_data.label }}</span> 차트가 적용된 보고 지표가 있습니다. 삭제 시 적용된 모든 지표에서 해당 내용이 사라지며,
          다시 복구할 수 없습니다.
        </p>
        <b-button variant="red" @click="showDeleteModal">차트 삭제</b-button>
      </b-col>
    </b-row>

    <b-button @click="handleCancle" class="mt-3">리스트로 돌아가기</b-button>

    <b-modal id="deleteModal" ref="deleteModal" centered title="삭제 확인">
      <p>차트를 사용하고 있는 모든 지표에서 삭제되며 되돌릴 수 없습니다. 삭제하시겠습니까?</p>
      <template v-slot:modal-footer="{ ok }">
        <b-button variant="danger" @click="confirmDelete">삭제</b-button>
        <b-button variant="secondary" @click="ok()">취소</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { gri_mixin } from '@/components/writing_report/write_report_subs/gri_mixin';

export default {
  name: 'ManageChart',
  mixins: [gri_mixin],
  props: {
    editing_mode: { type: Boolean, default: () => false },
  },
  computed: {
    ...mapState('report_list', ['report_code']),
    ...mapState('charts', [
      'chart_linked_indicators',
      'selected_chart_id',
      'selected_chart_data',
      'gri_linked_indicators',
      'sasb_linked_indicators',
      'tcfd_linked_indicators',
      'storyboard_linked_indicators',
    ]),
  },
  methods: {
    ...mapActions('charts', ['update_delete_chart']),

    showDeleteModal() {
      this.$refs.deleteModal.show();
    },

    async confirmDelete() {
      this.update_delete_chart({
        report_code: this.report_code,
        chart_id: this.selected_chart_id,
        linked_indicators: {
          gri_linked_indicators: this.gri_linked_indicators[this.selected_chart_id],
          sasb_linked_indicators: this.sasb_linked_indicators[this.selected_chart_id],
          tcfd_linked_indicators: this.tcfd_linked_indicators[this.selected_chart_id],
          chart_linked_indicators: this.chart_linked_indicators[this.selected_chart_id],
        },
      });
      this.$emit('removeChild');
      this.handleCancle();
    },

    handleCancle() {
      if (this.editing_mode) {
        this.$emit('flag_modal_mode', 'chart_list');
      } else {
        this.$emit('closeEditChartModal');
      }
    },
  },
};
</script>

<style></style>
